import React from 'react';
import PropTypes from 'prop-types';
import SMFormSelectBox from 'components/dashboard/form/SMFormSelectBox';
import SMConst from 'lib/SMConst';

class SMReservationEditViewUseType extends React.Component{

  selectBoxDidChangeValue(e) {
    this.props.delegate.changeUseType(e.currentTarget.name, e.currentTarget.value);
  }
  
  render() {
    const useTypes = [
      {value:SMConst.ReservationUseType.Indivisual, label:'個人利用'},
      {value:SMConst.ReservationUseType.Corporate, label:'法人利用'}
    ];
    
    let selectedValue = null;
    for (let i=0; i < useTypes.length; i++) {
      if (this.props.useType == useTypes[i].value) {
        selectedValue = useTypes[i].value;
      }
    }
    
    return(
      <td>
        <span className="form-select__inner">
          <label className="form-select">
            <SMFormSelectBox
              name='use_type'
              items={useTypes}
              selectedValue={selectedValue}
              delegate={this}
              options={{className:'w140'}} />
          </label>
        </span>
      </td>
    );
  }
}

SMReservationEditViewUseType.propTypes = {
  useType: PropTypes.string.isRequired,
  delegate: PropTypes.object
};
export default SMReservationEditViewUseType;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/shared/SMReservationEditViewUseType.jsx